import { render, staticRenderFns } from "./Gdpr.vue?vue&type=template&id=5ae60c68&"
import script from "./Gdpr.vue?vue&type=script&lang=js&"
export * from "./Gdpr.vue?vue&type=script&lang=js&"
import style0 from "./Gdpr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports